import React, { useState } from 'react';
import { m, AnimatePresence } from "framer-motion";
import { Keyboard, MousePointer2, Plus, ArrowLeft, ArrowRight, X, HelpCircle, ChevronUp, ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function ControlsHelp() {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="fixed bottom-6 right-6 z-[60] hidden lg:block">
            <AnimatePresence>
                {isOpen && (
                    <m.div
                        initial={{ opacity: 0, scale: 0.9, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.9, y: 20 }}
                        className="mb-4 w-72 bg-white/90 dark:bg-[hsl(225,14%,10%)]/95 backdrop-blur-md border border-amber-100 dark:border-amber-900/40 rounded-2xl shadow-2xl p-5 overflow-hidden ring-1 ring-black/5"
                    >
                        <div className="flex items-center justify-between mb-4 border-b border-amber-50 dark:border-amber-900/30 pb-2">
                            <h3 className="font-bold text-gray-900 dark:text-white flex items-center gap-2">
                                <Keyboard className="w-5 h-5 text-amber-600 dark:text-amber-400" />
                                Commandes PC
                            </h3>
                            <button
                                onClick={() => setIsOpen(false)}
                                className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors"
                            >
                                <X className="w-4 h-4" />
                            </button>
                        </div>

                        <div className="space-y-4">
                            {/* Keyboard Arrows */}
                            <div className="flex items-center gap-4">
                                <div className="flex gap-1.5">
                                    <kbd className="px-2 py-1.5 text-xs font-semibold text-gray-800 dark:text-gray-200 bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg shadow-sm">
                                        <ArrowLeft className="w-3 h-3" />
                                    </kbd>
                                    <kbd className="px-2 py-1.5 text-xs font-semibold text-gray-800 dark:text-gray-200 bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg shadow-sm">
                                        <ArrowRight className="w-3 h-3" />
                                    </kbd>
                                </div>
                                <div className="text-sm">
                                    <p className="font-medium text-gray-700 dark:text-gray-300">Like / Nope</p>
                                    <p className="text-xs text-gray-500 dark:text-gray-400">Utilisez les flèches</p>
                                </div>
                            </div>

                            {/* Mouse Drag */}
                            <div className="flex items-center gap-4">
                                <div className="w-10 h-10 flex items-center justify-center bg-amber-50 dark:bg-amber-950/40 text-amber-600 dark:text-amber-400 rounded-xl">
                                    <MousePointer2 className="w-5 h-5" />
                                </div>
                                <div className="text-sm">
                                    <p className="font-medium text-gray-700 dark:text-gray-300">Swipe avec souris</p>
                                    <p className="text-xs text-gray-500 dark:text-gray-400">Pour swiper à la souris</p>
                                </div>
                            </div>

                            {/* Collection */}
                            <div className="flex items-center gap-4">
                                <div className="w-10 h-10 flex items-center justify-center bg-orange-50 dark:bg-orange-950/40 text-amber-600 dark:text-amber-400 rounded-xl">
                                    <Plus className="w-5 h-5" />
                                </div>
                                <div className="text-sm">
                                    <p className="font-medium text-gray-700 dark:text-gray-300">Collection</p>
                                    <p className="text-xs text-gray-500 dark:text-gray-400">Ajouter à une collection</p>
                                </div>
                            </div>
                        </div>

                        <div className="mt-5 pt-4 border-t border-amber-50 dark:border-amber-900/30 text-[10px] text-gray-400 text-center italic">
                            Astuce: Cliquez sur l'icône agrandir pour voir l'image en grand
                        </div>
                    </m.div>
                )}
            </AnimatePresence>

            <Button
                onClick={() => setIsOpen(!isOpen)}
                className={`w-14 h-14 rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 group ${isOpen
                    ? 'bg-gray-900 hover:bg-black text-white'
                    : 'bg-gradient-to-r from-amber-600 to-amber-700 hover:from-amber-700 hover:to-amber-800 text-white shadow-amber-900/20'
                    }`}
                size="icon"
            >
                {isOpen ? (
                    <X className="w-6 h-6 transition-transform group-hover:rotate-90" />
                ) : (
                    <HelpCircle className="w-7 h-7" />
                )}
            </Button>
        </div>
    );
}
